import HttpClient from "shared/repositories/HttpClient";
import { GetTagListParams, GetTagListRes, GetTagRes, ID } from "shared/types";

export class TagRepository {
  private getObjectPath(id?: ID) {
    return id ? `/tags/${id}` : undefined;
  }

  private getListPath() {
    return `/tags`;
  }

  public getObject(id: ID) {
    const path = this.getObjectPath(id);

    return {
      path,
      data: () => HttpClient.miror.get<GetTagRes>(path).then((res) => res.data),
    };
  }

  public getList({ metaDescriptionType, ids }: GetTagListParams) {
    const path = this.getListPath();

    let params: Record<string, any> = { metaDescriptionType };

    if (ids) {
      params = { ...params, ids: ids.join(",") };
    }

    return {
      path,
      data: () =>
        HttpClient.miror
          .get<GetTagListRes>(path, { params })
          .then((res) => res.data),
    };
  }
}
